(function() {
  const tasaDOP = 60.00;
  const tasaEUR = 0.95;
  const paisesUSD = ["US", "CA"];
  const paisesEUR = ["ES", "IT", "FR", "DE"];

  let tasaActual = tasaDOP;
  let simboloActual = "RD$";
  let modoOriginal = false;

  function formato(num, moneda) {
    let locale = (moneda === "€") ? 'es-ES' : 'en-US';
    return (num < 0 ? "−" : "") + moneda + " " +
      Math.abs(num).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function convertirTexto(nodo) {
    if (modoOriginal) return;

    // BUSCADOR QUIRÚRGICO: Detecta el precio y opcionalmente la palabra USD al final para borrarla
    const regexUSD = /\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d{2}))(?:\s?USD)?/gi;

    nodo.querySelectorAll("*:not(script):not(style):not(textarea)").forEach(el => {
      el.childNodes.forEach(child => {
        if (child.nodeType === 3) {
          const txt = child.textContent;
          
          if (txt.includes('$') && !el.dataset.convertido) {
            const nuevo = txt.replace(regexUSD, (match, cantidad) => {
              const limpio = parseFloat(cantidad.replace(/,/g, ""));
              if (isNaN(limpio) || limpio === 0) return match;

              const convertido = limpio * tasaActual;
              return formato(convertido, simboloActual);
            });

            if (nuevo !== txt) {
              child.textContent = nuevo;
              el.dataset.convertido = "true";
            }
          }
        }
      });
    });
  }

  function inicializarObserver() {
    convertirTexto(document.body);
    new MutationObserver(muts => {
      muts.forEach(m => {
        m.addedNodes.forEach(n => {
          if (n.nodeType === 1) convertirTexto(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  fetch("https://ipapi.co/json/")
    .then(r => r.json())
    .then(data => {
      const pais = data.country_code; 
      if (paisesUSD.includes(pais)) {
        modoOriginal = true;
      } else if (paisesEUR.includes(pais)) {
        tasaActual = tasaEUR;
        simboloActual = "€";
      } else {
        tasaActual = tasaDOP;
        simboloActual = "RD$";
      }
      inicializarObserver();
    })
    .catch(() => { inicializarObserver(); });
})();